/**
 * Las tarifas por vehículo viajan dentro de la `description` (contrato F1, sin
 * columna propia): el seed agrega una línea final con el formato
 *   "Tarifas por vehículo: Microbús $200 · Coaster $320 · Bus $450."
 * Este parser la separa del cuerpo para no repetirla bajo el selector de
 * vehículo, con fallback al texto completo si el formato no está.
 */
export interface TourTariffLine {
  label: string
  price: string
}

export interface ParsedTourDescription {
  body: string
  tariffs: TourTariffLine[]
}

const TARIFF_LINE = /Tarifas? por vehículo:\s*(.+?)\.?\s*$/i

export function parseTourDescription(description: string): ParsedTourDescription {
  const match = description.match(TARIFF_LINE)
  const captured = match?.[1]
  if (match?.index == null || !captured) {
    return { body: description.trim(), tariffs: [] }
  }

  const body = description.slice(0, match.index).trim()
  const tariffs = captured
    .split('·')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const priceMatch = part.match(/^(.+?)\s+(\$[\d.,]+)$/)
      if (priceMatch?.[1] && priceMatch[2]) {
        return { label: priceMatch[1].trim(), price: priceMatch[2] }
      }
      return { label: part, price: '' }
    })

  return { body, tariffs }
}
